// Must stay the first import so errors and API calls made while other modules load are captured.
import { reactRootErrorHandlers } from './monitoring/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import './styles/dark-theme.css';
import reportWebVitals from './reportWebVitals';
import { queryClient } from './services/queryClient';
import logger from './utils/logger';

// Initialize i18n (this sets up translations and RTL support)
import './i18n/config';

// React Query DevTools intentionally disabled.
// This project currently uses React 19, while some common devtools packages can introduce peer-dependency conflicts.
// If you want DevTools later, add the dependency and re-enable this in a controlled upgrade window.
// eslint-disable-next-line no-unused-vars
const ReactQueryDevtools = null;

// Ensure queryClient is properly initialized
if (!queryClient) {
  logger.error('QueryClient is not initialized!');
}

const root = ReactDOM.createRoot(document.getElementById('root'), reactRootErrorHandlers);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in the app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
